<template>
  <div class="init-process-box">
    <!-- 平台选择器 -->
    <div style="margin-bottom: 16px;">
      <CustomTabs
        :height="24"
        :tabs="platfromOptions"
        v-model="activePlatformId"
        @change="handleTabsChange"
      ></CustomTabs>
    </div>
    <div class="sync-box">
      <div class="sync-pedding-box" v-show="pageType === 1">
        <div class="sync-process-box">
          <span>同步进程</span>
          <el-progress class="sync-process" :stroke-width="10" :percentage="percentage"></el-progress>
        </div>
        <div class="sync-p">{{platformTip}}</div>
        <el-tabs class="sync-list-box" tab-position="left" v-model="changeValue">
          <el-tab-pane v-for="item in shopList" :key="item.shopId" :name="item.shopId" label="123">
            <div slot="label" style="max-width: 200px;display: flex">
              <div v-if="item.syncing">
                <i class="el-icon-loading"></i>
              </div>
              <TipsStr style="flex: 1; margin-left: 4px" :content="getTabLabel(item)" />
            </div>
            <vxe-table
              ref="mainTable"
              align="center"
              height="100%"
              :data="item.taskList"
              resizable
              highlight-hover-row
              show-overflow
            >
              <vxe-column
                min-width="120px"
                title="模块"
                field="taskName">
              </vxe-column>
              <vxe-column
                min-width="120px"
                title="状态"
                field="taskStatus">
              </vxe-column>
              <vxe-column
                min-width="120px"
                title="详情"
                field="taskDetail"
                :formatter="formatterStr">
              </vxe-column>
            </vxe-table>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="sync-success-box" v-show="!isLoading && pageType === 2">
        <i class="el-icon-circle-check success-icon"></i>
        <span>店铺初始化已完成！</span>
      </div>
    </div>
  </div>
</template>

<script>
import { PLATFORM_ENUM_ALL } from '@/services/enums'
import { enumToOptions } from '@/services/utils/modules/base'
import CustomTabs from '@/components/tabs/index.vue'

export default {
  components: {
    CustomTabs,
  },
  name: 'InitProcess',
  data() {
    return {
      // pageType: 0, // 页面状态 有数据为1  全部成功为2
      changeValue: '', // 已选择店铺 shopId
      // shopList: [],
      setIntv: null,
      activePlatformId: '',
      platformShopListDict: {}, // 平台 -- 店铺列表 字典
      isLoading: false,
    }
  },
  computed: {
    platformTip() {
      let msg = '初始化所需时间从1小时到12小时不等，由您授权的店铺数量、订单量大小、财务数据量所决定。'

      if (this.activePlatformId === -99) {
        // amazon广告提示语句
        msg = '初始化广告所需时间从20分钟到3小时不等，由您授权的广告店铺数量、广告日数据量所决定。'
      }

      return msg
    },
    percentage() {
      const findObj = this.shopList.find(item => item.shopId === this.changeValue)
      if (findObj) {
        return findObj.syncProgress
      }
      return 0
    },
    // 平台可选项
    platfromOptions() {
      const ret = []
      const options = enumToOptions(PLATFORM_ENUM_ALL)
      // 手动插入一个 亚马逊广告
      options.splice(1, 0, {
        value: -99,
        label: 'Amazon广告',
        id: -99,
        name: 'Amazon广告',
      })

      options.forEach(tab => {
        const serverPlatformObj = this.platformShopListDict[tab.value]
        if (serverPlatformObj && serverPlatformObj.platformShopList && Array.isArray(serverPlatformObj.platformShopList) && serverPlatformObj.platformShopList.length > 0) {
          const syncingShop = serverPlatformObj.platformShopList.find(item => item.syncing === true)
          // 判断是否加载中
          ret.push({
            ...tab,
            isLoading: !!syncingShop
          })
        }
      })

      return ret
    },
    // 当前平台对应的shopList
    shopList() {
      return this.platformShopListDict[this.activePlatformId]?.platformShopList || []
    },
    // 当前平台 页面状态 有数据为1  全部成功为2
    pageType() {
      return this.shopList.length > 0 ? 1 : 2
    },
  },
  watch: {
    platfromOptions: {
      handler(val) {
        if (!val || val.length === 0) {
          return
        }

        // 修正当前平台
        this.fixActivePlatform()

        // 修正当前店铺
        this.fixActiveShop()
      },
      immediate: true,
    },
  },
  created() {
    this.firstGetList()
    this.setIntv = setInterval(this.getlist, 10000)
  },
  methods: {
    getTabLabel(item) {
      return `${item.shopName}-${this.$utils.pipeCountryCode(item.countryCode)}`
    },
    handleTabsChange() {
      // 修正 shopId
      this.fixActiveShop()
    },
    fixActivePlatform() {
      const platformItem = this.platfromOptions.find(item => item.value === this.activePlatformId)
      if (!platformItem) {
        this.activePlatformId = this.platfromOptions[0] ? this.platfromOptions[0].value : ''
      }
    },
    fixActiveShop() {
      const shopItem = this.shopList.find(item => item.shopId === this.changeValue)
      if (!shopItem) {
        this.changeValue = this.shopList[0] ? this.shopList[0].shopId : ''
      }
    },
    async firstGetList() {
      this.isLoading = true
      this.$emit('loading', true)
      await this.getlist()
      this.isLoading = false
      this.$emit('loading', false)
    },
    async getlist() {
      const { code, data } = await this.$request(this.$api.mallAuth.listSyncShop)
      if (code === 200) {
        const platformShopListDict = {};
        (data || []).forEach(item => {
          platformShopListDict[item.platformId] = item
        })
        this.platformShopListDict = platformShopListDict

        // old logic
        // this.shopList = data
        // if (data.length > 0) {
        // this.pageType = 1
        // if (this.changeValue) {
        //   const findObj = data.find(item => item.shopId === this.changeValue)
        //   if (!findObj) {
        //     this.changeValue = data[0].shopId
        //   }
        // } else {
        //   this.changeValue = data[0].shopId
        // }
        // } else {
        // this.pageType = 2
        // }
      }
    },
    formatterStr({ cellValue }) {
      if (!cellValue) return '-'
      return cellValue
    }
  },
  beforeDestroy() {
    clearInterval(this.setIntv)
    this.$store.commit('user/SET_INIT_BTN_SHOW', this.pageType !== 2)
  }
}
</script>

<style lang="scss" scoped>
.init-process-box {
  padding: 16px;
}
.sync-box{
  height: 400px;
  .sync-pedding-box{
    height: 100%;
    display: flex;
    flex-flow: column;
    .sync-process-box{
      display: flex;
      align-items: center;
      .sync-process{
        margin-left: 10px;
        flex: 1;
      }
    }
    .sync-p{
      margin-top: 10px;
    }
    .sync-list-box{
      flex: 1;
      margin-top: 20px;
    }
  }
}
.sync-success-box{
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  .success-icon{
    color: $main-color;
  }
}
::v-deep .el-tabs__content, .el-tabs__content .el-tab-pane{
  height: 100%;
}
::v-deep .el-tabs--left .el-tabs__nav.is-left, .el-tabs--left .el-tabs__nav.is-right, .el-tabs--right .el-tabs__nav.is-left, .el-tabs--right .el-tabs__nav.is-right {
  height: 100%;
  overflow-y: auto;
}
::v-deep .el-tabs--left .el-tabs__nav.is-left{
  background-color: $G2;
  .is-active{
    background-color: #ffffff;
  }
}
</style>
